import React, { useState } from "react";
import PropTypes from "prop-types";
import style from "./ButtonCall.module.sass";

function ButtonCall(props) {
  const { checked, onClick, imgOn, imgOff, customClass } = props;
  const [currentChecked, setCurrentChecked] = useState(checked);

  const onClickHandler = async (event) => {
    setCurrentChecked(event.target.checked);
    if (onClick) {
      const result = await onClick();
      if (result == false) {
        event.target.checked = !event.target.checked;
      }
    }
  };

  return (
    <div
      className={`${style.ButtonCall} ${customClass}`}
      onClick={onClickHandler}
    >
      <input type={"checkbox"} defaultChecked={currentChecked}></input>
      <img src={imgOn} className={`${style.on}`} />
      <img src={imgOff} className={`${style.off}`} />
    </div>
  );
}

ButtonCall.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  imgOn: PropTypes.string,
  imgOff: PropTypes.string,
};

ButtonCall.defaultProps = {
  checked: false
};

export default ButtonCall;